import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { TextAreaWebElement } from './TextAreaWebElement';
export { TextAreaWebElement };

/**
 * Retrieve an instance of [TextAreaWebElement](../classes/TextAreaWebElement.html).
 * @example
 * ```javascript
 * import { findTextArea } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findTextArea(driver, By.id('my-oj-c-text-area'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findTextArea(driver: DriverLike, by: By): Promise<TextAreaWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type TextAreaWebElement
  if (!(webEl instanceof TextAreaWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'TextAreaWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findTextArea(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${TextAreaWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-text-area', TextAreaWebElement);
